import { render, staticRenderFns } from "./StickerListIframe.vue?vue&type=template&id=a507442e&"
import script from "./StickerListIframe.vue?vue&type=script&lang=ts&"
export * from "./StickerListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports